export const LOCALSTORAGE_USER_SESSION_KEY = '__crehana__user__session';
